// NewsletterSubscribeMain.js
import React, { useState } from 'react';

const NewsletterSubscribeMain = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState(null);

  const API_URL =
    "https://c08ecwt84i.execute-api.eu-north-1.amazonaws.com/newsletter-subscribe";

  const handleSubmit = async () => {
    if (!email || !email.includes("@")) {
      setError("Please enter a valid email");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setError(null);

    try {
      console.log("Making API call to:", API_URL);

      const response = await fetch(API_URL, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const text = await response.text();
      console.log("Received response:", response.status, text);

      if (!response.ok) throw new Error(text || "Subscription failed");

      setStatus("success");
      setEmail("");
    } catch (err) {
      console.error("API Error:", err);
      setError(err.message || "Subscription failed");
      setStatus("error");
    }
  };

  return (
    <section className="mt-16 bg-blue-50 p-8 rounded-xl border border-blue-200">
      <h2 className="text-2xl font-bold text-blue-900 mb-4">
        Subscribe to Security Briefings
      </h2>
	  <p className="text-gray-700 mb-6">Get our latest cloud security insights and vulnerability alerts directly to your inbox.</p>

      {status === "success" ? (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
          Success! Thank you for subscribing.
        </div>
      ) : (
        <>
         

          {status === "error" && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          {/* No form tag — just input + button */}
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              className="flex-grow px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
              required
              disabled={status === "loading"}
            />
            <button
              type="button" // ✅ prevents accidental form submission
              onClick={handleSubmit}
              className={`${
                status === "loading"
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              } text-white font-medium py-3 px-6 rounded-lg transition duration-200 min-w-[120px] flex justify-center`}
              disabled={status === "loading"}
            >
              {status === "loading" ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </>
              ) : (
                "Subscribe"
              )}
            </button>
          </div>
        </>
      )}

      <p className="text-sm text-gray-500 mt-3">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </section>
  );
};

export default NewsletterSubscribeMain;
